// PhonicsLt09.js
// 包装组件：Letter Teams L09
// 路由：/phonics/lt09
import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterDataLt09 } from './phonics/phonics_data_lt09';

function PhonicsLt09() {
  return <PhonicsLt letterData={letterDataLt09} />;
}

export default PhonicsLt09;
